
import React, { useState, useEffect, useRef} from "react";
import app from "../../../firebaseConfig";
import { getDatabase, ref, get } from "firebase/database";
import { motion } from "framer-motion"; // Importamos framer-motion
import { useNavigate,useSearchParams } from "react-router-dom"; // Importamos useNavigate

import Lottie from "react-lottie-player";
import rayoazul from './assets/lottie/rayoazul.json';
import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';

import CarruselImagenes from "./3dfyrioncarruselimgs";
import BannerRotativo from "./3dfyrionbannerrotativo"; //
import Testimonios from "./3dfyriontestimonios"; //

import { FaBars, FaShoppingCart, FaUser, FaSearch } from "react-icons/fa";


import { cacheImage } from "../../../utils/cacheImage";

// Función para mezclar un array aleatoriamente (Fisher-Yates Shuffle)
const shuffleArray = (array) => {
    return array
      .map((item) => ({ item, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ item }) => item);
  };
  // Hook para calcular progreso basado en categorías cargadas en productosPorCategoria
  function useCargaProgresiva({ productosPorCategoria }) {
    const [progreso, setProgreso] = useState(0);
    const [completo, setCompleto] = useState(false);
  
    useEffect(() => {
      const categoriasCargadas = Object.keys(productosPorCategoria).length;
  
      if (categoriasCargadas === 0) {
        setProgreso(0);
        return;
      }
  
      // Calcular cuántas categorías se esperan realmente
      let totalEsperado = 0;
  
      // productosPorCategoria ya contiene solo las categorías visibles que vas cargando
      totalEsperado = categoriasCargadas;
  
      // ahora medimos progreso real
      const pct = Math.round((categoriasCargadas / totalEsperado) * 100);
  
      setProgreso(pct);
      setCompleto(pct >= 100);
    }, [productosPorCategoria]);
  
    return { progreso, completo };
  }
  

  
  
  export default function AwooEntrada({ setView, navigate }) {

  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [carritoCantidad, setCarritoCantidad] = useState(0); // 🔹 Estado del carrito

  const [searchParams] = useSearchParams();
  const mesa = searchParams.get("mesa"); // Obtiene el número de la mesa

  const [mostrarBusqueda, setMostrarBusqueda] = useState(false);

  const [productosP, setProductosP] = useState([]);
const [productosD, setProductosD] = useState([]);

const [productosPorCategoria, setProductosPorCategoria] = useState({});
const categoriasRefs = useRef({});

const [mostrarBotonArriba, setMostrarBotonArriba] = useState(false);

const isMobile = typeof window !== "undefined" && window.innerWidth <= 480;
const [menuAbierto, setMenuAbierto] = useState(false);

  const [productos, setProductos] = useState([]);

  const toggleBusqueda = () => {
    setMostrarBusqueda(!mostrarBusqueda);
  };

  //////////////// Por si se ve en CEL LOGICA DE REDIMENSION
  const [esMovil, setEsMovil] = useState(false);

  const categoryRefs = useRef({});
  const categoriasRef = useRef(null);

  const [activeCategory, setActiveCategory] = useState(null);


// helper para generar ids/keys sin espacios
const slugify = (str) =>
    String(str)
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "");


      const handleCategoriaClick = (categoriaNombre) => {
        const slug = slugify(categoriaNombre);
        const el = categoryRefs.current[slug] || document.getElementById(`cat-${slug}`);
        if (!el) return;
      
        // intentar detectar el header/top nav si existe (ajusta selector si tu nav tiene otra clase/id)
        const headerEl =
          document.querySelector(".top-nav") ||
          document.querySelector("header") ||
          document.querySelector("#navbar") ||
          null;
      
        const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 80; // fallback 80px
        const extraOffset = 12; // ajuste fino (margen)
        const top = window.scrollY + el.getBoundingClientRect().top - headerHeight - extraOffset;
      
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      
        // opcional: marcar como activa (para cambiar estilo)
        setActiveCategory(slug);
      };
      

      


  useEffect(() => {
    const manejarResize = () => {
      setEsMovil(window.innerWidth < 600); // ← Define punto de quiebre para "pantallas pequeñas"
    };

    manejarResize(); // Ejecutar en el primer render
    window.addEventListener("resize", manejarResize);
    return () => window.removeEventListener("resize", manejarResize);
  }, []);
  /////////////


  // Arreglo de animaciones disponibles
  const animacionesDisponibles = [
    lineasblancasvolando,
    efectoparticulas,
    fuegoamarillo,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    neutron,
    ondacircular,
    ondacircular,
    ondacircular,
    fuegoamarillo,
  ];
  

  //---------------------------------------------------------------------------------
  const tiempoMaximoCache = 1000 * 60 * 30; // 30 minutos
// Guardar y obtener productos del localStorage
  const guardarProductosEnLocalStorage = (productos) => {
    const data = {
      productos,
      timestamp: Date.now(),
    };
    localStorage.setItem("productosSoporteCelular", JSON.stringify(data));
  };
  
  const obtenerProductosDeLocalStorage = () => {
    const data = localStorage.getItem("productosSoporteCelular");
    if (!data) return null;
  
    const { productos, timestamp } = JSON.parse(data);
    if (Date.now() - timestamp > tiempoMaximoCache) return null; // Expirado
    return productos;
  };
  //---------------------------------------------------------------------------------
  




// 🔹 Función para obtener el carrito desde localStorage
const obtenerCarrito = () => {
  const carrito = localStorage.getItem("carrito");
  return carrito ? JSON.parse(carrito) : [];
};

     // 🔹 Obtener carrito al cargar la página
     useEffect(() => {
      setCarritoCantidad(obtenerCarrito().length);
    }, []);


  ////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);
////////////////////////

  // Función para navegar a awoovistaitem.js
  const verProducto = (producto) => {
    navigate("/3dfyrionvista", {
      state: {
        categoria: producto.categoria,   // ← AQUÍ VIENE LA CATEGORÍA
        producto: producto,              // ← Envías todo el objeto
        mesa: mesa,
      },
      replace: true,
    });
  };

  //////////////////////////////////////////////////////////////////////
//Codigo para cargar categorias
useEffect(() => {
    const db = getDatabase(app);
    const categoriasRef = ref(db, "nature/Awoo/Categorias");
  
    // Obtener categorías
    get(categoriasRef).then((snapshot) => {
      if (snapshot.exists()) {
        const categoriasData = snapshot.val();
        const categoriasArray = Object.keys(categoriasData);
  
        // Obtener imágenes y verificar visibilidad
        Promise.all(
          categoriasArray.map(async (categoria) => {
            const visibleSnapshot = await get(ref(db, `nature/Awoo/Control/Visible/Categorias/${categoria}`));
            const visible = visibleSnapshot.exists() ? visibleSnapshot.val().toLowerCase() : "no"; // Si no existe, por defecto "no"
  
            if (visible === "si") {
              const imgSnapshot = await get(ref(db, `nature/Awoo/Img/${categoria}`));
              const imgUrl = imgSnapshot.exists() ? imgSnapshot.val() : "";
              return { nombre: categoria, img: imgUrl };
            }
            return null; // Retorna null si no debe mostrarse
          })
        ).then((data) => {
          const categoriasFiltradas = data.filter((item) => item !== null); // Elimina los null
          setCategorias(shuffleArray(categoriasFiltradas)); // Mezcla y actualiza el estado
        });
      }
    });
  }, []);

// Categoria - Lista de todos los productos
// 🔥 CARGAR TODOS LOS PRODUCTOS POR CATEGORÍA
// ------------------------------------------------------------
// 🔥 CARGA OPTIMIZADA DE PRODUCTOS POR CATEGORÍA
// ------------------------------------------------------------
useEffect(() => {
    let abort = false; // por si el componente se desmonta
  
    async function cargarTodosProductos() {
      try {
        const db = getDatabase(app);
  
        // 1️⃣ Intentar cargar desde CACHE (rápido)
        const cacheLocal = localStorage.getItem("productosPorCategoria");
        if (cacheLocal) {
          console.log("⚡ Cargando productos desde CACHE");
          if (!abort) setProductosPorCategoria(JSON.parse(cacheLocal));
          return;
        }
  
        console.log("📡 Leyendo productos desde Firebase (progresiva)...");
  
        // 2️⃣ Leer VISIBILIDAD de categorías
        const visibilidadRef = ref(db, "nature/Awoo/Control/Visible/Categorias");
        const visSnapshot = await get(visibilidadRef);
        const categoriasVisibles = visSnapshot.exists() ? visSnapshot.val() : {};
  
        // 3️⃣ Leer TODAS las categorías y sus productos
        const categoriasRef = ref(db, "nature/Awoo/Categorias");
        const snapshot = await get(categoriasRef);
        if (!snapshot.exists()) return;
  
        const categoriasData = snapshot.val();
  
        // Mantener resultado parcial mientras vamos procesando categorías
        const resultadoParcial = {};
  
        const keysCategorias = Object.keys(categoriasData);
  
        for (const categoriaKey of keysCategorias) {
          if (abort) break;
  
          const visibleControl = categoriasVisibles[categoriaKey];
          if (!visibleControl || visibleControl.toLowerCase() !== "si") {
            console.log(`⛔ Categoría oculta: ${categoriaKey}`);
            continue;
          }
  
          const productosDeCategoria = categoriasData[categoriaKey];
          if (!productosDeCategoria) continue;
  
          resultadoParcial[categoriaKey] = [];
  
          // Procesar productos de la categoría
          for (const productoKey of Object.keys(productosDeCategoria)) {
            if (abort) break;
            const prod = productosDeCategoria[productoKey];
            if (!prod) continue;
  
            const esVisible =
              prod.visibilidad?.toLowerCase() === "si" ||
              prod.Visibilidad?.toLowerCase() === "si";
            if (!esVisible) continue;
  
            // Creamos el objeto producto (sin bloquear por imágenes)
            const productoProcesado = {
              id: productoKey,
              categoria: categoriaKey,
              ...prod,
              imgCached: null,
            };
  
            // Si tiene Img o Visuales, iniciamos cacheImage pero NO esperamos
            if (prod.Img) {
              // cacheImage devuelve una promesa; cuando termine actualizamos el estado (no bloqueante)
              cacheImage(prod.Img, productoKey).then((img) => {
                // actualizamos la referencia de imagen en el estado existente
                setProductosPorCategoria((prev) => {
                  // si usuario ya navegó lejos o prev no contiene la categoria, evitamos crash
                  if (!prev || !prev[categoriaKey]) return prev;
                  // buscamos el producto y actualizamos su imgCached
                  const nuevaLista = prev[categoriaKey].map((p) =>
                    p.id === productoKey ? { ...p, imgCached: img } : p
                  );
                  return { ...prev, [categoriaKey]: nuevaLista };
                });
              });
            } else if (prod.Visuales) {
              const visualesArray = Object.values(prod.Visuales)
                .filter((v) => v?.tipo === "imagen")
                .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));
  
              if (visualesArray.length > 0) {
                const imgUrl = visualesArray[0].url;
                cacheImage(imgUrl, productoKey).then((img) => {
                  setProductosPorCategoria((prev) => {
                    if (!prev || !prev[categoriaKey]) return prev;
                    const nuevaLista = prev[categoriaKey].map((p) =>
                      p.id === productoKey ? { ...p, imgCached: img } : p
                    );
                    return { ...prev, [categoriaKey]: nuevaLista };
                  });
                });
              }
            }
  
            // Agregamos inmediatamente el producto procesado a la lista parcial
            resultadoParcial[categoriaKey].push(productoProcesado);
          } // fin loop productos
  
          // Mezcla aleatoria de esta categoría
          resultadoParcial[categoriaKey] = resultadoParcial[categoriaKey].sort(
            () => 0.5 - Math.random()
          );
  
          // ⚡ Actualizamos el estado incrementalmente por categoría (esto es la carga progresiva)
          setProductosPorCategoria((prev) => {
            const siguiente = { ...(prev || {}), [categoriaKey]: resultadoParcial[categoriaKey] };
            // Opcional: actualizar cache incremental (si quieres persistir rápidamente)
            try {
              localStorage.setItem("productosPorCategoria", JSON.stringify(siguiente));
            } catch (e) {
              // si falla (storage full), lo ignoramos
            }
            return siguiente;
          });
  
          // small delay opcional muy corto para dar tiempo al render (descomentar si lo deseas)
          // await new Promise((res) => setTimeout(res, 30));
        } // fin loop categorias
  
        if (!abort) {
          console.log("✅ Carga progresiva completada");
          // asegurar que la cache final está guardada
          try {
            localStorage.setItem("productosPorCategoria", JSON.stringify(resultadoParcial));
          } catch (e) {}
        }
      } catch (err) {
        if (!abort) console.error("🔥 Error cargando productos (progresiva):", err);
      }
    }
  
    cargarTodosProductos();
  
    return () => {
      abort = true;
    };
  }, []); // ← mantener empty deps como en tu versión original (no cambié la semántica)
  
  
  
  
//Detectar si las categorías están visibles
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // Si el bloque de categorías se ve → ocultamos botón
        setMostrarBotonArriba(!entry.isIntersecting);
      },
      { threshold: 0.2 } // 20% visible
    );
  
    if (categoriasRef.current) observer.observe(categoriasRef.current);
  
    return () => {
      if (categoriasRef.current) observer.unobserve(categoriasRef.current);
    };
  }, []);



  






///////////////////
//Codigo para barra deslizante infinita
const mensajes = [
    "🚚 Envíos a toda Colombia",
    "⏳ ¡Tiempo limitado!",
    "🎉 Después de 5 Unidades Descuento 30%",
    "💎 Exclusivo en nuestra tienda",
    "🎯 Ideal para regalar",
    "🎈 ¡Aprovecha antes que se agote!"
  ];

  // Repetimos los mensajes para dar continuidad
  const contenido = [...mensajes, ...mensajes];
///////////////



  
  // 🔹 Función para redirigir al resumen de compras
  const irAlCarrito = () => {
    navigate("/3dfyrionresumen", { state: { mesa } });
  };


// Loader estilo CardTranslucido adaptado
// Loader estilo CardTranslucido adaptado (versión NO full-screen)
function LoaderAwoo({ progreso }) {
    const mostrarSpinner = progreso === 0;
  
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          flexDirection: "column",
          padding: "30px 0",
          background: "#000", // si prefieres sin fondo, pon 'transparent'
        }}
      >
        {/* Logo */}
        <div
          style={{
            width: "110px",
            height: "110px",
            borderRadius: "50%",
            backgroundColor: "#26e9f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "18px",
            boxShadow: "0 0 18px rgba(38,233,246,0.6)",
          }}
        >
          <div
            style={{
              width: "94px",
              height: "94px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#444",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="images/dragonfondo.png"
              alt="logo"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>
  
        {/* 🔵 Loader circular mientras está en 0% */}
        {mostrarSpinner && (
          <div
            style={{
              border: "5px solid #333",
              borderTop: "5px solid #00e5ff",
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              marginBottom: "12px",
              animation: "spin 1s linear infinite",
            }}
          />
        )}
  
        {/* Barra progreso — solo cuando progreso > 0 */}
        {!mostrarSpinner && (
          <>
            <div
              style={{
                width: "70%",
                maxWidth: "340px",
                height: "12px",
                backgroundColor: "#333",
                borderRadius: "10px",
                overflow: "hidden",
                marginBottom: "8px",
              }}
            >
              <div
                style={{
                  width: `${progreso}%`,
                  height: "100%",
                  background: "linear-gradient(90deg, #00e5ff, #00b3cc)",
                  transition: "width .15s ease",
                }}
              />
            </div>
  
            <p style={{ color: "#eee", fontWeight: "bold", marginTop: "4px" }}>
              Cargando tienda... {progreso}%
            </p>
          </>
        )}
  
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }
  
  
  
// ¿Todavía no han cargado los productos? → Mostrar loader
const estaCargando =
  Object.keys(productosPorCategoria).length === 0 ||
  categorias.length === 0;


  const { progreso, completo } = useCargaProgresiva({
    categorias,
    productosPorCategoria
  });
  

    return (
        <div style={{ display: "flex",overflowX: "hidden" , width: "100%", boxSizing: "border-box", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "#000", color: "white", textAlign: "center"}}>    

{/* ------------------ BARRA LATERAL ------------------------ */}
<motion.div
  initial={{ x: "-100%" }}
  animate={{ x: menuAbierto ? 0 : "-100%" }}
  transition={{ duration: 0.3, ease: "easeOut" }}
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "280px",
    height: "100vh",
    backgroundColor: "#111",
    color: "#fff",
    zIndex: 9999,
    padding: "20px",
    boxShadow: "4px 0 12px rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  }}
>
  {/* Botón cerrar */}
  <div style={{ display: "flex", justifyContent: "flex-end" }}>
    <button
      onClick={() => setMenuAbierto(false)}
      style={{
        background: "none",
        border: "none",
        color: "white",
        fontSize: "26px",
        cursor: "pointer",
      }}
    >
      ✖
    </button>
  </div>

  {/* Opciones principales */}
  <div style={{ marginTop: "10px", marginBottom: "20px" }}>
    {["INICIO", "PRODUCTOS", "SIMULADORES"].map((opcion) => (
      <div
        key={opcion}
        onClick={() => {
          if (opcion === "INICIO") navigate("/");
          if (opcion === "PRODUCTOS") navigate("/3dfyrioninicioproductos");
          if (opcion === "SIMULADORES") navigate("/3dfyrioninicionosotros");
          setMenuAbierto(false);
        }}
        style={{
          padding: "12px 0",
          paddingLeft: "5px",
          fontWeight: "bold",
          fontSize: "16px",
          cursor: "pointer",
          borderBottom: "1px solid #333",
        }}
      >
        {opcion}
      </div>
    ))}
  </div>

  {/* Categorías visibles */}
  <div style={{ marginTop: "10px" }}>
    <h3 style={{ fontSize: "14px", color: "#bbb", marginBottom: "10px" }}>
      CATEGORÍAS
    </h3>

    {categorias.map((cat, index) => (
      <div
        key={index}
        onClick={() => {
          handleCategoriaClick(cat.nombre);
          setMenuAbierto(false);
        }}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 0",
          cursor: "pointer",
          borderBottom: "1px solid #222",
          gap: "10px",
        }}
      >
        <img
          src={cat.img}
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "6px",
            objectFit: "cover",
          }}
        />
        <span style={{ fontSize: "15px" }}>{cat.nombre}</span>
      </div>
    ))}
  </div>
</motion.div>

{/* Fondo oscuro cuando menú está abierto */}
{menuAbierto && (
  <div
    onClick={() => setMenuAbierto(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 9998,
    }}
  ></div>
)}
{/* ---------------------------------------------------------- */}



  {/* Encabezado */}
  <div
      style={{
        width: "100%",
        height: "70px",
        backgroundColor: "#111",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      {/* Lado izquierdo - botón de menú y logo + lupa */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginLeft: "15px",
        }}
      >
        
      {/* <FaBars size={35} style={{ cursor: "pointer" }} /> */}
      <FaBars 
  size={35} 
  style={{ cursor: "pointer" }} 
  onClick={() => setMenuAbierto(true)}
/>

        
        <img
          src="images/dragonfondo2.png"
          alt="Logo"
          style={{
            height: "75px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
        <FaSearch
          size={20}
          style={{ cursor: "pointer" }}
          onClick={toggleBusqueda}
        />
      </div>

      {/* Centro - barra de búsqueda */}
      {mostrarBusqueda && (
        <input
          type="text"
          placeholder="Buscar..."
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            width: "50%",
            height: "35px",
            borderRadius: "8px",
            padding: "0 15px",
            border: "none",
            outline: "none",
            fontSize: "16px",
          }}
        />
      )}

      {/* Lado derecho - carrito + contador + perfil */}
{/* --- Icono Carrito Compras (Se oculta si carritoCantidad es 0) --- */}
{carritoCantidad > 0 && (
  <div
    onClick={irAlCarrito}
    style={{
      position: "relative",
      width: "48px",
      cursor: "pointer",
      marginRight:"19px"
    }}
  >
    <div
      style={{
        width: "38px",
        height: "38px",
        borderRadius: "50%",
        border: "3px solid #2ae5e2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('images/carrito.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    ></div>

    {/* Etiqueta inferior con cantidad */}
    <div
      style={{
        position: "absolute",
        bottom: "-10px",
        left: "45%",
        transform: "translateX(-50%)",
        backgroundColor: "#fa0a02",
        color: "white",
        padding: "4px 5px",
        borderRadius: "10px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "12px",
      }}
    >
      {carritoCantidad}
    </div>
  </div>
)}
    </div>

    {/* BARRA DE NAVEGACIÓN */}
<div
  style={{
    width: "100%",
    backgroundColor: "#111",
    display: "flex",
    justifyContent: "center",
    padding: "10px 0",
    boxShadow: "0 2px 10px rgba(0,0,0,0.5)",
    position: "sticky", // opcional: se queda arriba
    top: 0,
    zIndex: 999,
  }}
>
  <div
    style={{
      width: "95%",
      maxWidth: "1200px",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      gap: "20px",
      flexWrap: "wrap", // para que sea responsive
    }}
  >
    
    
    {["INICIO", "PRODUCTOS", "SIMULADORES"].map((opcion) => (
  <button
    key={opcion}
    onClick={() => {
      if (opcion === "INICIO") setView("INICIO");
      if (opcion === "PRODUCTOS") setView("PRODUCTOS");
      if (opcion === "SIMULADORES") setView("SIMULADORES");
    }}
    style={{
      background: opcion === "PRODUCTOS" ? "white" : "none",
      color: opcion === "PRODUCTOS" ? "black" : "white",
      border: "none",
      fontWeight: "bold",
      fontSize: "11px",
      cursor: "pointer",
      padding: "12px",
      borderRadius: "6px",
    }}
  >
    {opcion}
  </button>
))}


  </div>
</div>

  {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
         marginTop:"2px"
      }}
    >
    </div>




  {/* Barra Deslizante */}
  <div
      style={{
        width: "100%",
        height: "35px",
        backgroundColor: "#222",
        color: "#fff",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: "bold",
      }}
    >
      <div
        style={{
          display: "inline-block",
          whiteSpace: "nowrap",
          animation: "mover 8s linear infinite",
        }}
      >
        {contenido.map((texto, index) => (
          <span key={index} style={{ marginRight: "60px" }}>
            {texto}
          </span>
        ))}
      </div>

      {/* Animación CSS */}
      <style>
        {`
          @keyframes mover {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </div>

  {/* Animación de fondo */}
   <div
  style={{
    marginLeft: "15px",
    position: "relative",
    flexShrink: 0, // Evita que las tarjetas se reduzcan
  }}
>

 {/* Animación de fondo */}
 <Lottie
      animationData={animacionSeleccionada} // Importa correctamente la animación JSON
      play
      loop
      style={{
        position: 'absolute', // Fija la animación al fondo de la ventana
        justifyContent: "center",
        width: '700px',
        height: '700px',
        top: '0',
        left: '0',
        zIndex: 0, // Detrás del contenido
        pointerEvents: 'none', // Para que no interfiera con los clics
      }}
    />


   </div>


    {/* Loader superpuesto, pero NO bloquea el render */}
    {!completo && <LoaderAwoo progreso={progreso} />}

{/* CONTENIDO QUE SE OCULTA HASTA QUE LA CARGA TERMINE */}
<div style={{ display: completo ? "block" : "none" , width:"100%"}}>


{/* Título + Botón CATEGORIAS */}
<div
  ref={categoriasRef}
  style={{
    width: "100%",
    padding: "10px 0",
    display: "flex",
    justifyContent: "center", // 🔄 Cambiar aquí
    alignItems: "center",
    marginTop:"30px",
  }}
>
  <div style={{ fontWeight: "bold", fontSize: "16px", color: "white" }}>
  ✔️ CATEGORIAS
  </div>
</div>
{/* Botones de opciones */}
<div
      style={{
        marginTop:"-30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        textAlign: "center",
        padding: "10px",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: esMovil ? "10px" : "20px",
          width: "95%",
          padding: "10px",
        }}
      >
        {categorias.map((categoria, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            style={{
              cursor: "pointer",
              width: esMovil ? "70px" : "120px", // ← Ajuste para pantallas pequeñas
            }}
            onClick={() => handleCategoriaClick(categoria.nombre)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                padding: "10px 0",
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  maxWidth: esMovil ? "70px" : "120px",
                }}
              >
                <div
                  style={{
                    padding: "2px",
                    backgroundColor: "#4df9fc",
                    borderRadius: "50%",
                    width: "100%",
                  }}
                >
                  <img
                    src={categoria.img}
                    alt={categoria.nombre}
                    style={{
                      width: "100%",
                      height: esMovil ? "70px" : "120px",
                      objectFit: "cover",
                      borderRadius: "50%",
                      display: "block",
                    }}
                  />
                </div>
                <div
                  style={{
                    position: "absolute",
                    bottom: "-10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "70%", // Más ancho en móvil
                    backgroundColor: "#3cca07",
                    color: "white",
                    padding: "6px",
                    borderRadius: "10px",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: esMovil ? "12px" : "14px",
                  }}
                >
                  {categoria.nombre}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>

{/* BLOQUE COMPLETO DE "Bloque toos los productos por categoria" */}
{Object.keys(productosPorCategoria).map((categoria) => {
  const slug = slugify(categoria);

  return (
    <div
      key={categoria}
      id={`cat-${slug}`}
      ref={(el) => (categoryRefs.current[slug] = el)}
      style={{
        width: "100%",
        margin: "20px 0",
        backgroundColor: "#000",
        padding: "20px 0",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          display: "flex",
          flexDirection: "column",
          margin: "0 auto",
        }}
      >
        {/* Título + Ver Más */}
        <div
          style={{
            width: "100%",
            padding: "10px 0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ fontWeight: "bold", fontSize: "20px", color: "white" }}>
            🛒 {categoria}
          </div>

          <button
            style={{
              backgroundColor: "#8ac20b",
              color: "white",
              fontWeight: "bold",
              border: "none",
              borderRadius: "20px",
              padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
            }}
            onClick={() => console.log(`Ver más de ${categoria}`)}
          >
            Ver Más
          </button>
        </div>

        {/* Grid de productos */}
        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: isMobile
              ? "repeat(2, minmax(120px, 1fr))"
              : "repeat(auto-fit, minmax(160px, 1fr))",
            gap: isMobile ? "8px" : "12px",
          }}
        >
          {productosPorCategoria[categoria].map((producto) => {
            const tienePrecioAnterior =
              producto.PrecioAnterior && producto.PrecioAnterior !== 0;

            const porcentajeDescuento = tienePrecioAnterior
              ? Math.round(
                  100 - (producto.Precio * 100) / producto.PrecioAnterior
                )
              : null;

            return (
              <div
                key={producto.id}
                onClick={() => verProducto(producto)}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: isMobile ? "8px" : "10px",
                  textAlign: "center",
                  border: "1px solid #02f2fa",
                  boxShadow: "0 0 10px rgba(2, 242, 250, 0.7)",
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <img
                  src={producto.imgCached || producto.Img || "images/default.jpg"}
                  style={{
                    width: "100%",
                    height: isMobile ? "120px" : "150px",
                    objectFit: "cover",
                    borderRadius: "10%",
                  }}
                />

                {tienePrecioAnterior && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      left: "8px",
                      backgroundColor: "#b016b5",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    -{porcentajeDescuento}% OFF
                  </div>
                )}

                <div
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    marginTop: "10px",
                  }}
                >
                  {producto.Titulo}
                </div>

                {tienePrecioAnterior && (
                  <div
                    style={{
                      color: "#7c7c7c",
                      fontWeight: "bold",
                      textDecoration: "line-through",
                    }}
                  >
                    ${producto.PrecioAnterior.toLocaleString("es-CO")}
                  </div>
                )}

                <div
                  style={{
                    marginTop: "5px",
                    backgroundColor: "#57a710",
                    color: "white",
                    padding: "5px",
                    borderRadius: "10px",
                    fontWeight: "bold",
                  }}
                >
                  ${producto.Precio?.toLocaleString("es-CO") || "0"}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
})}





<BannerRotativo />




  {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
         marginTop:"9px",
         width:"100%"
      }}
    >
    </div>






{/* Nombre de usuario */}
<div
  style={{
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#fff",
    marginBottom: "15px",
    marginTop:"8px"
  }}
>
  @3dfyrion
</div>

{/* Footer */}
<div
  style={{
    width: "100%",
    padding: "15px 0",
    textAlign: "center",
    fontSize: "14px",
    color: "#777",
    borderTop: "1px solid #ccc",
  }}
>
  <span style={{ fontSize: "16px", marginRight: "5px" }}>©</span>
  2025, 3dFyrion Colombia | Tecnología y Diseño de 3dfyrion
</div>


{mostrarBotonArriba && (
  <button
    onClick={() => {
      categoriasRef.current?.scrollIntoView({ behavior: "smooth" });
    }}
    style={{
      position: "fixed",
      bottom: "25px",
      right: "25px",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      backgroundColor: "#017bff",
      color: "white",
      border: "none",
      fontSize: "30px",
      cursor: "pointer",
      boxShadow: "0px 4px 15px rgba(0,0,0,0.4)",
      zIndex: 9999,
    }}
  >
    ↑
  </button>
)}



</div> {/* FIN DEL CONTENIDO OCULTO */}





</div>
    );
}



let _preloadPromise = null;
export function preloadProductos() {
  if (_preloadPromise) return _preloadPromise;

  _preloadPromise = (async () => {
    try {
      const db = getDatabase(app);

      // 1) Si ya hay cache válida en localStorage, devolverla
      const cacheLocal = localStorage.getItem("productosPorCategoria");
      if (cacheLocal) {
        console.debug("preloadProductos: cargado desde cache local");
        return JSON.parse(cacheLocal);
      }

      // 2) Leer visibilidad de categorias
      const visSnapshot = await get(ref(db, "nature/Awoo/Control/Visible/Categorias"));
      const categoriasVisibles = visSnapshot.exists() ? visSnapshot.val() : {};

      // 3) Leer todas las categorias
      const categoriasRef = ref(db, "nature/Awoo/Categorias");
      const snapshot = await get(categoriasRef);
      if (!snapshot.exists()) return {};

      const categoriasData = snapshot.val();
      const resultado = {};

      for (const categoriaKey of Object.keys(categoriasData)) {
        const visibleControl = categoriasVisibles[categoriaKey];
        if (!visibleControl || (visibleControl + "").toLowerCase() !== "si") continue;

        const productosDeCategoria = categoriasData[categoriaKey];
        if (!productosDeCategoria) continue;

        resultado[categoriaKey] = [];

        for (const productoKey of Object.keys(productosDeCategoria)) {
          const prod = productosDeCategoria[productoKey];
          if (!prod) continue;

          const esVisible = (prod.visibilidad || prod.Visibilidad || "").toLowerCase() === "si";
          if (!esVisible) continue;

          resultado[categoriaKey].push({
            id: productoKey,
            categoria: categoriaKey,
            ...prod,
            imgCached: null,
          });
        }
      }

      // Guardar cache final
      try {
        localStorage.setItem("productosPorCategoria", JSON.stringify(resultado));
      } catch (e) {
        console.warn("preloadProductos: fallo guardando cache", e);
      }

      // Prefetch imágenes (no bloqueante)
      for (const cat of Object.keys(resultado)) {
        for (const p of resultado[cat]) {
          const url = p.Img || (p.Visuales && Object.values(p.Visuales)[0]?.url);
          if (url) {
            const img = new Image();
            img.src = url;
          }
        }
      }

      console.debug("preloadProductos: terminado");
      return resultado;
    } catch (err) {
      console.error("preloadProductos error:", err);
      return {};
    }
  })();

  return _preloadPromise;
}


const botonEstilo = {
    width: "100%",
    padding: "15px",
    fontSize: "18px",
    fontWeight: "bold",
    background: "#e27f0e",
    color: "white",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
};
